module.exports = __webpack_public_path__ + "img/TTMarxiana-Antiqua.e53f1bf2.svg";